"use client";

import { PRIORITY_OPTIONS } from "@/features/leads/shared/priority";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";
import { RadioCards } from "@/shared/ui/form/RadioCards";

export function PriorityStep() {
  const { autoAdvance, next, back, canAdvance, isBusiness } = useWizard();
  const [{ priority = "" }, answer] = useStep("priority");

  return (
    <section>
      <StepHeading
        title={isBusiness ? "Hvad betyder mest for jer?" : "Hvad betyder mest for dig?"}
        body={
          isBusiness
            ? "Firmaet, I bliver matchet med, kan se jeres svar, inden de ringer."
            : "Firmaet, du bliver matchet med, kan se dit svar, inden de ringer."
        }
        maxW="max-w-[28ch]"
      />
      <RadioCards
        options={PRIORITY_OPTIONS}
        value={priority}
        onChange={(v) => {
          answer({ priority: v });
          autoAdvance();
        }}
      />
      <StepNav onBack={back} onNext={next} nextEnabled={canAdvance} nextLabel="Næste →" />
    </section>
  );
}
